
  import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      EmptyStateEntry,
    },
  });
